import {accordion, homeLink} from '../common';
import * as mobileCss from './mobile.scss';
import * as desktopCss from './desktop.scss';

export default ({mainLinks, t, config, tAll}) => `

  <div class="${desktopCss.aside}">
    <a href="${homeLink(config.language)}" class="${desktopCss.asideLogo}" title="${tAll('title_wix_logo')}" tabindex="${config.tabIndex[1]}">Wix.com</a>
    <p class="${desktopCss.asideParagraph}">${t('description')}</p>
    <p class="${desktopCss.asideParagraph}">${t('closing_line1')} ${t('closing_line2')}</p>
  </div>

  ${accordion(mainLinks, {
    accordionWrapper: mobileCss.accordion__wrapper,
    accordion: mobileCss.accordion,
    accordionHeader: mobileCss.accordion__header,
    accordionPanel: mobileCss.accordion__panel,
  }, null, config.tabIndex[1])}

  <div class="${mobileCss.copyrights}">${t('closing_years')}</div>
`;
